import { render, staticRenderFns } from "./DeskUpdate.vue?vue&type=template&id=598a54e2&"
import script from "./DeskUpdate.vue?vue&type=script&lang=js&"
export * from "./DeskUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports